import { isRequired } from '../../utils.js';

const context = _ref => {
  let {
    context_page_id = isRequired('context_page_id'),
    context_page_type = isRequired('context_page_type'),
    destination = isRequired('destination')
  } = _ref;
  return () => ({
    context_page_id: String(context_page_id),
    context_page_type,
    destination
  });
};

export default context;
export { context };
